import dynamic from 'next/dynamic';
import { useTranslation } from 'next-i18next';
import { ShopsNewIcon } from '@components/icons/new/shops-new-icon';
import { ShopsNewViewall } from '@components/icons/new/shops-new-viewall';
import Link from '@components/ui/link';
import { useRouter } from 'next/router';
import { useShopsPaginationQuery } from './shops.query';
import { ROUTES } from '@lib/routes';
import cn from "classnames";
import { isMobileOnly } from 'react-device-detect';

const ErrorMessage = dynamic(() => import("@components/ui/error-message"));
const GridWithLoader = dynamic(() => import("@components/shared/grid-with-loader"));
const ShopCard = dynamic(() => import("@components/shops/card"));

export default function ShopsNewMobile() {
  const { t } = useTranslation();
  const router = useRouter();
  const locale = router.locale;

  const {
    isLoading,
    isError,
    error,
    data,
  } = useShopsPaginationQuery({
    locale,
    limit: 5,
    function: 'newShops'
  }, {
    staleTime: Infinity
  });

  if (isError && error) return <ErrorMessage message={error.message} />;
  if (!isLoading && data?.shops?.length == 0) return <></>;

  return (
    <div className={cn("list-shops-new list-shops-new-mobile sm:mt-[70px]", isMobileOnly ? "mt-3" : "mt-10")}>
      <div className="container mx-auto">
        <div className={cn("top-list-shops-new set-padding-0 mb-3")}>
					<div className={cn(isMobileOnly ? 'text-sm' : 'text-xl font-semibold not-italic uppercase flex text-blue-10')}>
          { !isMobileOnly &&  <span className="pr-4">{t('common:home-shop-news')}</span>}
            { !isMobileOnly && <ShopsNewIcon /> }
            {isMobileOnly && <span className="mr-1">{data?.paginatorInfo?.total || 0}</span>}
            {isMobileOnly && <span className="text-gray-1500">{t("minicart-sanpham")}</span>}
					</div>
          <Link href={ROUTES.NEW_SHOPS}>
            <span className={cn(isMobileOnly ? "mobile-see-all" : "")}>{t('common:home-shop-all')}</span>
            <ShopsNewViewall />
          </Link>
        </div>
        <GridWithLoader
          showLoaders={isLoading}
          limit={10}
        >
          {data?.shops?.map((shop: any, index: any) => <div key={`shop_featured_${index}`}>
            <ShopCard shop={shop} shopDetailPath={ROUTES.BEST_SHOPS} key={shop.id}/>
          </div>)}
        </GridWithLoader>
      </div>
    </div>
  );
}
